import { render, staticRenderFns } from "./collection-opinions.vue?vue&type=template&id=51a93e68&scoped=true"
import script from "./collection-opinions.vue?vue&type=script&lang=js"
export * from "./collection-opinions.vue?vue&type=script&lang=js"
import style0 from "./collection-opinions.vue?vue&type=style&index=0&id=51a93e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a93e68",
  null
  
)

export default component.exports